import { Col } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Summary, UserList } from './screens';

const Subscribe = ({}) => {
  const [page, setPage] = useState('select'),
    [data, setData] = useState(null),
    { athleteId } = useParams(),
    { isMobile } = useSelector((state) => state.appState),
    navigate = useNavigate(),
    location = useLocation(),
    { t } = useTranslation();

  // if(isMobile) return <GetTheApp alwaysShow />

  return (
    <Col wid="100%" bg="#F3F5F8" ht={isMobile ? '100%' : 'calc(100% - 73px)'} start>
      {page === 'select' && <UserList athleteId={athleteId} setPage={setPage} setData={setData} />}

      {page === 'summary' && (
        <Summary data={data} setData={setData} handleBack={() => setPage('select')} />
      )}
    </Col>
  );
};

export default Subscribe;
